import { motion } from "framer-motion";

/**
 * NoSaveImage — a plain <img> with drag/right-click disabled for the public
 * front end. This does not make the pixels uncopyable, only inconvenient.
 */
export default function NoSaveImage({ className = "", style, ...rest }) {
  return (
    <img
      {...rest}
      className={className}
      style={{
        userSelect: "none",
        WebkitUserSelect: "none",
        WebkitUserDrag: "none",
        pointerEvents: rest.onClick ? "auto" : "auto",
        ...style,
      }}
      draggable={false}
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
    />
  );
}

export const MotionNoSaveImage = motion(NoSaveImage);
